import { contactDataManagement as base } from './base';
import { contactDataManagement as AT } from './AT';
import { contactDataManagement as CZ } from './CZ';
import { contactDataManagement as RO } from './RO';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    RO,
};
